 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "vendors." + {"0":"dde0be11da296399661d","1":"dc5135126b0a88ad642b","2":"abb27d004a5fe2d8600e","3":"c5fe38553a66dcaab076","4":"eca4bd98d5238aeb0813","5":"73a49f7ae36505f9c5ea","6":"1aa9add4a7e0eccec7ec","7":"e4921a4daf76fc3d8869","vendors~Comment~ShareComment":"09fe270575817e8c8741","vendors~Comment~LoginDialog":"c71779834d93a7915300","vendors~Comment~Survey":"82b5e38d83ccdf099d9d","Comment":"fa15ec8afbe4f5aaef47","vendors~Player":"34ec7acebeeba160839b","Player":"29bec05d20fa6c70e168","AccountOpening":"efcc12029fef887ee8a1","BackTopBottom":"68d39e0966e3137b543a","Caption":"2e2a69cb3952fe4d796d","Copyright":"c7d2142842ff69bc24a6","DataBox":"fabd9a23ec8db9a90797","Img":"ceb3ef7599d71828a7db","LivePlayer":"7de1b0f87bc0d9d01d69","MoreTabs":"9bfb49b41c959980e269","Nav":"c199bd56aa650747af2d","NormalCaption":"98ea7a0b35d9a285a78e","Offline":"bab1510e797e432acd96","QQShare":"38f4698adc74508be782","Stick":"9f971f50013e2332c307","Tip":"032a47bc228407604d01","ViewMoreLink":"5e92cd8c82b1d3f51d30","WxLaunchApp":"c59a5cbc35626afd49df","vendors~Atlas~FiveNavPic~FourNavPic~InformationFlow~MdBanner~ThreeNavPic":"dd1c0a444d7f60f7c4d3","Atlas":"3aa9aee1dba3b11bd122","FiveNavPic":"6d1f07d6d48541faa395","FourNavPic":"b3ba07317a8b44c0e883","vendors~MdBanner":"1f30265e88066e2f3a5c","vendors~BigImage~BigImg~BigTopic~BottomSlides~BrowserGuideLayer~CallupHead~CallupVideoAppHead~HomeFo~464104dc":"57ffa910b969402df079","CallupVideoAppHead":"1ea8391f493874fa7427","HomeFooter":"af32fb662ce366f0b3a8","Hongbao":"dd2e3f540432da536a8c","TwoImage":"91100ab020d9db886b07","ThreeNavPic":"3ddb766500277997c162","vendors~BigImage~NewsStream~NoImage~OneImage~ThreeImage":"d6a42f88f5d7e715c0bc","BigImage":"cac11f9aa761b8c1fd53","NoImage":"c2a6a54d616386c8cc8c","OneImage":"bdd20cb6a230d6b2404f","ThreeImage":"6d07093958a9e1800bf4","vendors~NewsStream":"1acbe437497b9c43130f","vendors~BigImg~BigTopic~InformationFlow~SingleTitle~SlideImg~TitleImg~TwoImg":"7d17f26e2de0cf3c9ec2","SingleTitle":"2fe56935907b5c5e5972","TwoImg":"632602155c034f5d0cf9","InformationFlow":"d64091e7d07a07b4c7da","vendors~BigImg":"01eaad67ba88794f182e","BigImg":"1561dedff4fd4df21791","vendors~BigTopic~TitleImg":"efc6915dfb8ff847aa31","BigTopic":"13ca2bcf2e3e6e6b2fef","TitleImg":"ff240a57b266b20cb25c","vendors~SlideImg":"de30a51eaf121f8cec3b","vendors~BottomSlides~IndexSlides~NormalSlides~ShareSlides~Slides~UpgradeBottomSlides":"a81fb2574f0a5ff631e4","NormalSlides":"0c7b2cd247c321d45805","ShareSlides":"d215dc3461e302725bad","vendors~BottomSlides~UpgradeBottomSlides":"587d3dd64c09cf802b7c","UpgradeBottomSlides":"0fed0eb086789266b8a9","vendors~IndexSlides":"d4fa320f55ed250aaf11","vendors~BrowserGuideLayer":"db17bc3188f6ad3f101b","vendors~CallupHead":"50edd5587eee26d0eb7f","vendors~ShareComment":"4a0abd285f9659f9eb2f","vendors~Survey":"d16eb76b74d60c3cf2e0","vendors~NormalTabs":"8ca2a147ae5367abb55a","vendors~WXGuideLayer":"4b7b104598186a1f2221","LoginDialog":"5653fa7fabe1ce277e01","vendors~MarkTabs":"7b444f80b1fe08f7154e","vendors~PageBottomBrand":"5a48f084c8afbec23172","vendors~SimpleGuideLayer":"426fc9235ecd80dbe4ce","vendors~SlidesTabs":"12b4223fc2308150eb21","vendors~pics":"f5bf5f92b6eee56bba1c","pics":"a16a6b2516cefa72fb1b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://x2.ifengimg.com/fe/shank/content/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
